import React from "react";
import checked from "./../../../../Images/checked.png";

const NailExtensionInJakkurWhy = () => {
  return (
    <div className="hairSalonInSahakaraWhy">
      <h5>Why SCENT is Your Top Choice for Nail Extensions Near Jakkur</h5>
      <p>
        When it comes to nail extensions near Jakkur, SCENT Salon stands out for
        several reasons:
      </p>
      <ul>
        <li>
          <span>
            <img src={checked} alt="checked" />
            Expertise and Experience{" "}
          </span>
          <p>
            Our skilled team has years of experience, ensuring you get
            impeccable results every time.
          </p>
        </li>{" "}
        <li>
          <span>
            <img src={checked} alt="checked" />
            Personalized Attention{" "}
          </span>
          <p>
            Each client receives one-on-one attention, with nail artists who
            take the time to understand your style and preferences.
          </p>
        </li>
        <li>
          <span>
            <img src={checked} alt="checked" />
            High-Quality Products{" "}
          </span>
          <p>
            We use only the best products to ensure your nail extensions look
            amazing and stay durable.
          </p>
        </li>
        <li>
          <span>
            <img src={checked} alt="checked" />A Comfortable and Inviting
            Atmosphere{" "}
          </span>
          <p>
            Our salon is designed to be a relaxing environment where you can
            enjoy a bit of pampering.
          </p>
        </li>
        <li>
          <span>
            <img src={checked} alt="checked" />
            Strict Hygiene Standards{" "}
          </span>
          <p>
            Your safety is our priority, and we follow rigorous hygiene
            protocols to ensure a clean, worry-free experience.
          </p>
        </li>
      </ul>
    </div>
  );
};

export default NailExtensionInJakkurWhy;
